import { BexioInvoice } from '@/bexio/invoice'
import { entryStatus } from '@/db/schema/_types'
import { Project, project } from '@/db/schema/project'
import { User, user } from '@/db/schema/user'
import { relations } from 'drizzle-orm'
import { decimal, integer, jsonb, PgColumn, pgEnum, pgTable, serial, text, timestamp } from 'drizzle-orm/pg-core'

export type IncomePositionsType = { hours: number; rate: number; name: string; positionCustomId?: string }
export type IncomeMealsType = { breakfast: number; lunch: number; dinner: number }

export const incomeType = pgEnum('income_type', [
  'expense_company_interest', // Firmenabgabe
  'income_intern_invoice',
  'income_extern_invoice',
  'income_extern_expense',
])

export const income = pgTable('income', {
  id: serial('id').primaryKey(),
  migrationId: text('migration_id'), // Migration ID
  integrationId: text('integration_id'), // Integration ID
  created: timestamp().defaultNow().notNull(),
  updated: timestamp().defaultNow().notNull(),
  createdBy: integer('created_by')
    .notNull()
    .references((): PgColumn => user.id)
    .notNull(),
  issued: timestamp().defaultNow().notNull(),
  name: text('name').notNull(),
  description: text('description'),
  amount: decimal('amount').notNull(),
  positions: jsonb('positions').$type<IncomePositionsType[]>().notNull(),
  url: text('url'),
  type: incomeType().notNull(),
  meals: jsonb('meals').$type<IncomeMealsType>(),
  status: entryStatus().notNull(),
  user: integer('user')
    .references((): PgColumn => user.id)
    .notNull(),
  project: integer('project')
    .references((): PgColumn => project.id)
    .notNull(),
})

export const incomeRelations = relations(income, ({ one }) => ({
  user: one(user, {
    fields: [income.user],
    references: [user.id],
    relationName: 'user',
  }),
  creditor: one(project, {
    fields: [income.project],
    references: [project.id],
    relationName: 'project',
  }),
}))

export type Income = typeof income.$inferSelect & { bexioInvoice?: BexioInvoice }
export type IncomeResolved = { income: Income; user: User; project: Project }
export type InsertIncome = typeof income.$inferInsert
export type UpdateIncome = Partial<Income>
